<template>
  <div id="instance">
    <keep-alive>
      <router-view v-if="$route.meta.keepAlive"></router-view>
    </keep-alive>
    <router-view v-if="!$route.meta.keepAlive"></router-view>
  </div>
</template>
<script>
export default {
  name: 'instance'
}
</script>




// WEBPACK FOOTER //
// src/views/process/instance/Instance.vue